import React, { useRef } from "react";
import emailjs, { send } from "@emailjs/browser";

import "./Join.css";

const Join = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_khyuu89",
        "template_twt0cvl",
        form.current,
        "IGfAoKfGfzbTFwBYP"
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );
  };

  return (
    <div className="Join" id="join-us">
      <div className="left-j">
        <hr />
        <div>
          <span className="stroke-text">SIAP</span>
          <span> MENATAP</span>
        </div>
        <div>
          <span>MASA DEPAN</span>
          <span className="stroke-text">BERSAMA KAMI?</span>
        </div>
      </div>
      <div className="right-j">
        <form
          ref={form}
          onSubmit={sendEmail}
          action=""
          className="email-container"
        >
          <input
            type="email"
            name="user_email"
            placeholder="Masukan alamat Email kamu"
          />
          <button className="btn btn-j">Join Now</button>
        </form>
      </div>
    </div>
  );
};

export default Join;
